import Vue from "vue"
import Vuex from "vuex"
Vue.use(Vuex)
const state = {
    permission: [],
    tableNameRouterLogo: '', //table name标签
    back_crumbs_text_name: '', //面包屑 二级路由 中文名称 ，table 进入页面之后 返回确保面包屑 中文路由显示正确
    amount:'',
    provider_type:'',
    userHide:[],
	userManageButtonAll:[],
    invoiceForm:[],
    addresForm:[],
    formSearchList:[],
    billingContent:[],
}

const mutations = {
    addPermission(state, data) {
        state.permission = data;
    },
    addInvoiceForm(state, data) {
        state.invoiceForm = data;
    },
    addBillingContent(state, data) {
        state.billingContent = data;
    },
    addAddresForm(state, data) {
        state.addresForm = data;
    },
    getFormSearch(state, data) {
        state.formSearchList = data;
    },
    getAmount(state, data) {
        state.amount = data;
    },
    addUserhide(state, data) {
        state.userHide = data;
    },
    getProvider_type(state, data) {
        state.provider_type = data;
    },
    TABLENAMEROUTERLOGO(state, data) {
        state.tableNameRouterLogo = data;
    },

    BACK_CRUMBS_TEXT_NAME(state, data) {
        state.back_crumbs_text_name = data;
    },
    addUserManage(state, data) {
        state.userManageButtonAll = data;
    },
}

const actions = {
    set_tableNameRouterLogo({ commit }, data) {

        commit('TABLENAMEROUTERLOGO', data)
    },
    set_backCrumbsTextName({ commit }, data) {
        commit('BACK_CRUMBS_TEXT_NAME', data)
    },
}


const getters = {
    tableNameRouterLogo: state => state.tableNameRouterLogo,
    backCrumbsTextName: state => state.back_crumbs_text_name,

}
export default new Vuex.Store({
    state,
    mutations,
    getters,
    actions
})



// WEBPACK FOOTER //
// ./src/store/index.js